var change = "Changement";
var edit = "Éditer";
var loading = "Chargement";
var logout = "Se déconnecter";
var support = "Centre d'aide en ligne";
var more = "Plus";
var yes = "Oui";
var no = "Non";
var exit = "Sortir";
var you = "Tu";
var search = "Recherche";
var fr = {
	"business-unit": "Unité commerciale",
	"ces-administration": "Administration de la SCÉ",
	change: change,
	"change-business-unit": "Changer d'unité commerciale",
	edit: edit,
	loading: loading,
	logout: logout,
	"no-application-available": "Aucune application disponible.",
	"select-a-business-unit-to-change": "Sélectionnez une unité commerciale vers laquelle passer. Si l'unité commerciale n'utilise pas votre application actuelle, vous serez redirigé vers votre profil.",
	support: support,
	"system-administration": "L'administration du système",
	more: more,
	yes: yes,
	no: no,
	"you-already-switched-to": "Vous êtes déjà passé à <bold>{{name}}</bold> il y a quelque temps. Voulez-vous changer <bold>{{name}}</bold> ici ?",
	"business-unit-has-changed": "L'unité commerciale a changé",
	exit: exit,
	"impersonated-user": "Utilisateur usurpé",
	you: you,
	"no-business-unit-assigned": "Aucune unité commerciale attribuée",
	"explore-marigold": "Explorer Marigold",
	"no-data-to-display": "Aucune donnée à afficher",
	search: search
};

export { change, fr as default, edit, exit, loading, logout, more, no, search, support, yes, you };
